import React, { useEffect, useState } from 'react'
import ModalInc from '../../../shared-ui/ModalInc'
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import { Autocomplete, Grid, TextField } from '@mui/material';
import { useStyle } from "./Style";
import ButtonInc from '../../../shared-ui/ButtonInc';
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import ProgressState from './ProgressState/ProgressState';
import {
  getS3BucketSignedUrlForEmailTemplatesV2,
  getTemplateDocuments,
} from '../../../lib/requests.es6';
import {
  emailEntityAttachments,
  emailNotifyRestrictions,
  emailTypesEntity,
} from '../../../lib/constants';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import uniqueCodes from '../../SmsTemplate/template_codes';
const emptyForm = {
  code: '',
  language: 'en',
  subject: '',
  filename: '',
  active: true,
  recipients: '',
  cc_recipients: '',
  attachments: [],
  entity_attachments: [],
  entity_type: '',
  notify_restriction: '',
};

const AddEmailTemplate = (props) => {
  const classes = useStyle();

  const [s3Url] = useState('https://s3.eu-west-1.amazonaws.com/partner-email-templates');
  const [progress, setProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null)
  const [error, setError] = useState('');
  const [documentOptions, setDocumentOptions] = useState([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [formData, setFormData] = useState(emptyForm);

  useEffect(function () {
    if (!props.open) {
      return;
    }

    setFormData(emptyForm);
    setProgress(0);
    setErrorMessage(null);
    setError('');

    setLoadingDocuments(true);
    getTemplateDocuments()
      .then(function (response) {
        setDocumentOptions(response.data || []);
      })
      .catch(function () {
        setDocumentOptions([]);
      })
      .finally(function () {
        setLoadingDocuments(false);
      });
  }, [props.open]);

  const parseCsvToArray = function (value) {
    if (!value) {
      return [];
    }

    return value
      .split(',')
      .map(function (item) {
        return item.trim();
      })
      .filter(function (item) {
        return item.length > 0;
      });
  };

  const handleChange = function (event) {
    var name = event.target.name;
    var value = event.target.value;
    if (
      (name === 'attachments' || name === 'entity_attachments') &&
      typeof value === 'string'
    ) {
      value = value.split(',');
    }
    setFormData(function (prevData) {
      return {
        ...prevData,
        [name]: value,
      };
    });
  };

  const handleFinishedUpload = (info) => {
    var uploadedFilename = info.bucketKey;
    setFormData(function (prevData) {
      return {
        ...prevData,
        filename: uploadedFilename,
      };
    });
  }

  const submitCreate = function () {
    var recipients = parseCsvToArray(formData.recipients);
    var ccRecipients = parseCsvToArray(formData.cc_recipients);
    var payload = {
      code: formData.code.trim(),
      language: formData.language.trim(),
      subject: formData.subject.trim(),
      filename: formData.filename.trim(),
      active: formData.active === true,
      recipients: recipients,
      cc_recipients: ccRecipients,
      attachments: formData.attachments,
      entity_attachments: formData.entity_attachments,
      entity_type: formData.entity_type,
      notify_restriction: formData.notify_restriction,
    };
    props.saveEmailTemplate(payload);
  };

  const getS3Ur = (file, callback) => getS3BucketSignedUrlForEmailTemplatesV2(file, callback)

  const uploadOptions = {
    getSignedUrl: getS3Ur,
    s3Url: s3Url,
    uploadRequestHeaders: {},
    onProgress: (progress) => setProgress(progress),
    onError: (errorMessage) => setErrorMessage(errorMessage),

  };

  const reset = () => {
    setProgress(0)
    setError('');
    props.close();
  }

  var attachmentSelectionLabel = 'Select attachments from documents';
  if (loadingDocuments) {
    attachmentSelectionLabel = 'Loading document templates...';
  } else if (!documentOptions.length) {
    attachmentSelectionLabel = 'No document templates available';
  }


  return (
    <>
      <ModalInc
        modalTitle="Upload Email Template"
        subTitle="Fill the fields below then upload the template file"
        open={props.open}
        onClose={props.close}
        fullWidth
        maxWidth="md"
      >


        <ValidatorForm onSubmit={submitCreate} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <small style={{ color: '#777' }}>
                Fields marked with * are required.
              </small>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <Autocomplete
                  freeSolo
                  clearOnBlur={false}
                  selectOnBlur={false}
                  options={uniqueCodes}
                  value={formData.code}
                  onChange={function (event, newValue) {
                    if (newValue === null || newValue === undefined) {
                      return;
                    }
                    setFormData(function (prevData) {
                      return {
                        ...prevData,
                        code: String(newValue),
                      };
                    });
                  }}
                  onInputChange={function (event, newInputValue, reason) {
                    if (reason === 'input' || reason === 'clear') {
                      setFormData(function (prevData) {
                        return {
                          ...prevData,
                          code: newInputValue || '',
                        };
                      });
                    }
                  }}
                  renderInput={function (params) {
                    return (
                      <TextField
                        {...params}
                        id="code"
                        label="Template Code *"
                        placeholder="Code e.g. KYC_UPDATE"
                        variant="outlined"
                        fullWidth
                        className={classes.paymentinputs}
                        helperText={
                          'Pick a suggested code or type your own event code.'
                        }
                      />
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextValidator
                  name='language'
                  id="language"
                  label="Language *"
                  value={formData.language}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter language']}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <TextValidator
                  name='subject'
                  id="subject"
                  label="Email Subject *"
                  value={formData.subject}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter subject']}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <TextValidator
                  name='filename'
                  id="filename"
                  label="Body HTML Filename *"
                  value={formData.filename}
                  onChange={function () { }}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  disabled
                  helperText="Auto-filled after uploading the HTML template file."
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <DropzoneS3Uploader
                  onFinish={handleFinishedUpload}
                  upload={uploadOptions}
                  s3Url={s3Url}
                  passChildrenProps={false}
                  // {...(!hasAllfieldsFilled && { onDrop: () => setError('Please fill all required fields before uploading.') })}
                  maxSize={1024 * 1024 * 500}
                  className={classes.uploadzone}
                  style={{
                    width: "100%",
                    height: "160px",
                    background: "#FFFFFF",
                    border: "1px dashed #B8B8B8",
                    marginTop: "8px",
                    padding: "32px 0"
                  }}
                >
                  <div >
                    <ProgressState progress={progress} errorMessage={errorMessage} />
                  </div>
                </DropzoneS3Uploader>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <SelectValidator
                  name='entity_type'
                  labelId="entity_type"
                  id="entity_type"
                  value={formData.entity_type}
                  label="Entity Type *"
                  onChange={handleChange}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please select entity type']}
                  style={{ width: "100%" }}
                >
                  {
                    emailTypesEntity.map((type, index) => {
                      return <MenuItem
                        sx={{
                          fontFamily: "Open Sans",
                          fontStyle: "normal",
                          fontWeight: 300,
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0.005em",
                          color: "#000000",
                        }}
                        key={index}
                        value={type.value}>
                        {type.label}
                      </MenuItem>
                    })
                  }

                </SelectValidator>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <SelectValidator
                  name='notify_restriction'
                  labelId="notify_restriction"
                  id="notify_restriction"
                  value={formData.notify_restriction}
                  label="Notify Restriction *"
                  onChange={handleChange}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please select notify restriction']}
                  style={{ width: "100%" }}
                >
                  {
                    emailNotifyRestrictions.map((type, index) => {
                      return <MenuItem
                        sx={{
                          fontFamily: "Open Sans",
                          fontStyle: "normal",
                          fontWeight: 300,
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0.005em",
                          color: "#000000",
                        }}
                        key={index}
                        value={type.value}>
                        {type.label}
                      </MenuItem>
                    })
                  }
                </SelectValidator>
              </Grid>



              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name='recipients'
                  id="recipients"
                  label="Recipients"
                  value={formData.recipients}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  helperText="Optional extra addresses on top of the notify restriction. Comma separated, e.g 'test@email.com, test2@email.com'"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name='cc_recipients'
                  id="cc_recipients"
                  label="CC Recipients"
                  value={formData.cc_recipients}
                  onChange={handleChange}
                  fullWidth
                  className={classes.paymentinputs}
                  variant="outlined"
                  helperText="optional comma separated values"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="attachments-label">Attachments</InputLabel>
                  <Select
                    labelId="attachments-label"
                    id="attachments"
                    multiple
                    name="attachments"
                    value={formData.attachments}
                    onChange={handleChange}
                    label="Attachments"
                    renderValue={function (selected) {
                      if (!selected || !selected.length) {
                        return 'None';
                      }
                      return selected.join(', ');
                    }}
                  >
                    {documentOptions.map(function (doc, index) {
                      var value = doc.guid || doc.code || '';
                      if (!value) {
                        return null;
                      }
                      var label = doc.name || doc.code || doc.guid;
                      return (
                        <MenuItem key={index} value={value}>
                          {label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <small style={{ color: '#777', marginTop: '4px' }}>
                    {attachmentSelectionLabel}
                  </small>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="entity-attachments-label">
                    Entity Attachments
                  </InputLabel>
                  <Select
                    labelId="entity-attachments-label"
                    id="entity_attachments"
                    multiple
                    name="entity_attachments"
                    value={formData.entity_attachments}
                    onChange={handleChange}
                    label="Entity Attachments"
                    renderValue={function (selected) {
                      if (!selected || !selected.length) {
                        return 'None';
                      }
                      return selected.join(', ');
                    }}
                  >
                    {emailEntityAttachments.map(function (type, index) {
                      return (
                        <MenuItem key={index} value={type.value}>
                          {type.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <small style={{ color: '#777', marginTop: '4px' }}>
                    Optional entity-generated attachments.
                  </small>
                </FormControl>
              </Grid>


            </Grid>

            {props.errror && <p style={{ color: 'red' }}>{props.errror.message}</p>}
          </Grid>

          {error && <p style={{ color: 'red' }}>{error}</p>}
          <Grid container spacing={2} style={{ marginTop: '12px' }}>
            <Grid item xs={12} sm={6} md={6}>
              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                loading={props.loading}
                disabled={props.loading}
                style={{ width: '100%' }}
              >
                Save Template
              </ButtonInc>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <ButtonInc
                variant="contained"
                size="large"
                onClick={reset}
                disabled={props.loading}
                style={{ width: '100%', background: '#FBA92D' }}
              >
                Cancel
              </ButtonInc>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>

    </>
  )
}

export default AddEmailTemplate